<div id="loader" *ngIf="isLoader">
    <div id="shadow"></div>
    <div id="box"></div>
    <h4><b>Loading..</b></h4>
</div>
<div *ngIf="body">
    <mat-card style="background: transparent;">
        <mat-card class="card_style">

            <div>

                <div style="text-align: center; padding-top: 50px;">

                    <h1 style="margin-top: -18px;"><b>Nepal Automotive Market Study</b></h1>

                </div>
            </div>

            <div style="text-align:left;">
                <div>
                    <div style="margin-bottom: 2%;">
                        <img class="excel-button" src="https://cdn-icons-png.flaticon.com/128/732/732220.png" width="35"
                            height="35" (click)="excelExport()">
                    </div>
                     
                    <div class="table-responsive">
                        <table class="table" id="MarketStudy">
                            <thead >
                                <tr>

                                    <th scope="col" style="width: 40%;">Industry Type</th>
                                    <th scope="col" style="width: 40%;">Customer Name</th>
                                    <th scope="col" style="width: 40%;">Customer Category</th>
                                    <th scope="col" style="width: 40%;">Type Of Work</th>
                                    <th scope="col" style="width: 40%;">Whatsapp Number</th>
                                    <th scope="col" style="width: 40%;">Owners Nationality</th>
                                    <th scope="col" style="width: 40%;">How Old In The Market</th>
                                    <th scope="col" style="width: 40%;">Current Supplier Name</th>
                                    <th scope="col" style="width: 60%;">Delivery Duration</th>
                                   
                                   
                                    <th scope="col" style="width: 60%;">No Of Paint Booths</th>
                                    <th scope="col" style="width: 60%;">No Of Cars Monthly</th>
                                    <th scope="col" style="width: 60%;">No Of Painters</th>
                                    <th scope="col" style="width: 60%;">No Of panels_daily</th>
                                    <th scope="col" style="width: 60%;">No Of Panels Monthly</th>

                                    <th scope="col" style="width: 60%;">Body Filler Brands</th>
                                    <th scope="col" style="width: 60%;">Two K Primer Brand</th>
                                    <th scope="col" style="width: 60%;">Paint Brand</th>
                                    <th scope="col" style="width: 60%;">Clear Coat Brand</th>
                                    <th scope="col" style="width: 60%;">Abrasive Brand</th>

                                    <th scope="col" style="width: 60%;">Type Of Sanding</th>
                                    <th scope="col" style="width: 60%;">Abrasive Opportunity</th>
                                    <th scope="col" style="width: 60%;">Non Paint Consumables Opportunity</th>
                                    <th scope="col" style="width: 60%;">Paint Opportunity</th>
                                    <th scope="col" style="width: 60%;">Two K Primer Price</th>
                                    
                                    <th scope="col" style="width: 40%;">Body Filler Price</th>
                                    <th scope="col" style="width: 40%;">Paint Price</th>
                                    
                                    <th scope="col" style="width: 40%;">Clear Coat Price</th>
                                    <th scope="col" style="width: 40%;">Abrasive Price</th>
                                    <th scope="col" style="width: 40%;">Existing Credit Terms</th>
                                    <th scope="col" style="width: 40%;">Payment Behaviour</th>

                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let employee of Output">
                                    <tr>
                                      <td>{{employee.industry_type}}</td>
                                      <td>{{employee.customer_name}}</td>
                                      <td>{{employee.customer_category}}</td>
                                      <td>{{employee.type_of_work}}</td>
                                      <td>{{employee.whatsapp_number}}</td>
                                      <td>{{employee.owners_nationality}}</td>
                                      <td>{{employee.how_old_in_the_market}}</td>
                                      <td>{{employee.current_supplier_name}}</td>
                                      <td>{{employee.delivery_duration}}</td>
                                      <td>{{employee.no_of_paint_booths}}</td>
                                      <td>{{employee.no_of_cars_monthly}}</td>
                                      <td>{{employee.no_of_painters}}</td>
                                      <td>{{employee.no_of_panels_daily}}</td>
                                      <td>{{employee.no_of_panels_monthly}}</td>
                                      <td>{{employee.body_filler_brands}}</td>
                                      <td>{{employee.two_k_primer_brand}}</td>
                                      <td>{{employee.paint_brand}}</td>
                                      <td>{{employee.clear_coat_brand}}</td>
                                      <td>{{employee.abrasive_brand}}</td>
                                      <td>{{employee.type_of_sanding}}</td>
                                      <td>{{employee.abrasive_opportunity}}</td>
                                      <td>{{employee.non_paint_consumables_opportunity}}</td>
                                      <td>{{employee.paint_opportunity}}</td>
                                      <td>{{employee.two_k_primer_price}}</td>
                                      <td>{{employee.body_filler_price}}</td>
                                      <td>{{employee.paint_price}}</td>
                                      <td>{{employee.clear_coat_price}}</td>
                                      <td>{{employee.abrasive_price}}</td>
                                      <td>{{employee.existing_credit_terms}}</td>
                                      <td>{{employee.payment_behaviour}}</td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>

